import styled from 'styled-components';
import { ReactComponent as ArrowIcon } from './arrow.svg';
import { Warning as WarningIcon } from 'features/shared/ui/sharedStyled';
import { H3 } from 'features/shared/ui/Heading';

export const AccordionButton = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  cursor: ${(props) => (props.disabled ? 'pointer' : 'default')};
`;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

export const AccordionContent = styled.div`
  padding-bottom: 1px;
`;

export const Arrow = styled(ArrowIcon)`
  margin: -4px 0 0 4px;
  position: relative;
  top: 5px;
`;

export const AccordionWrapper = styled.div<{ collapse: boolean }>`
  &:not(:first-child) {
    margin-top: 40px;
  }
  &:not(:last-child) {
    margin-bottom: 64px;
  }

  ${AccordionContent} {
    transition: height 0.5s;
    overflow: hidden;
  }

  ${Arrow} {
    transform: rotate(${({ collapse }) => (collapse ? '0' : '180')}deg);
  }
`;

export const Date = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
  margin-bottom: 8px;
  a {
    &,
    &:focus,
    &:active,
    &:visited,
    &:hover {
      color: #12b7e7;
      margin-bottom: 12px;
      display: inline-block;
      outline: none;
    }
  }
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  padding-right: 40px;
`;

export const SubTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  margin: 16px 0;
`;

export const Link = styled.a`
  &,
  &:focus,
  &:active,
  &:visited,
  &:hover {
    color: #12b7e7;
    margin-bottom: 12px;
    display: inline-block;
    outline: none;
  }
`;

export const Space = styled.div`
  flex: 1 0 auto;
`;

export const Information = styled.div`
  width: 28px;
  height: 28px;
  margin: 0 8px -7px 0;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  flex: 0 0 auto;
  display: inline-block;
`;

export const Warning = styled(WarningIcon)`
  margin-right: 12px;
  flex: 0 0 auto;
`;

export const UnavalibelTable = styled.div`
  width: 808px;
`;

export const ButtonsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -16px;
  > * {
    margin-right: 16px;
    margin-bottom: 16px;
  }
`;

export const TableTitle = styled(H3)`
  display: flex;
  margin-bottom: 10px;
`;

export const TitleStatistics = styled(TableTitle)`
  color: rgba(9, 21, 38, 0.6);
`;
